import { render, staticRenderFns } from "./AiReport.vue?vue&type=template&id=6b4598c8&scoped=true&"
import script from "./AiReport.vue?vue&type=script&setup=true&lang=js&"
export * from "./AiReport.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4598c8",
  null
  
)

export default component.exports